import { render } from "./goods-info.vue?vue&type=template&id=3e069bcd"
import script from "./goods-info.vue?vue&type=script&lang=js"
export * from "./goods-info.vue?vue&type=script&lang=js"

import "./goods-info.vue?vue&type=style&index=0&id=3e069bcd&lang=css"
script.render = render

export default script